import LogoOnlyLayout from './LogoOnlyLayout';

export default LogoOnlyLayout;
